export default __webpack_public_path__ + "static/media/about-mobile.664b1b1a.jpg";